<template>
  <ValidationObserver ref="form" #default="{ dirty, valid }">

    <main class="content">
      <div class="content__heading content__heading--navigation">
        <h1>
          <i class="icon--location"></i> {{ $t('locations.listTitle') }}
          <small v-if="locationList !== 'undefined'">({{ locationList.length }})</small>
        </h1>

        <!--<nav class="navigation&#45;&#45;buttonGroup">
          <button @click="showModal" class="navigation&#45;&#45;buttonGroup__text">
            <i class="icon&#45;&#45;plus"></i> {{ $t('locations.add') }}
          </button>
        </nav>-->
      </div>

      <section class="content--boxed">
        <input :placeholder="$t('search.locations')" type="text" name="search" v-model="search" :required="false"
               class="input input--search"/>

        <div class="table table--badged" v-if="locationList.length > 0">
          <div class="table--badged__row table--badged__row--clickable" v-for="(location, i) in locationList"
               :key="i" @click="$router.push({name: 'location.city.index', params: {city: location.city}})">
            <div class="table--badged__badge table--badged__badge--light"><i class="icon--location"></i></div>
            <div class="table--badged__description">
              <h3>
                {{ location.city }}
              </h3>
            </div>
          </div>
        </div>
        <template v-if="total === 0">
          <div class="message" v-if="!isFilterApplied">
            {{ $t('messages.noLocations') }}
          </div>
          <div class="message" v-else>
            {{ $t('messages.noResults') }}
          </div>
        </template>
      </section>
      <DqPaginate v-if="lastPage > 1" v-model="page" :page-count="lastPage"
                  :click-handler="dispatchList"/>
    </main>
  </ValidationObserver>
</template>

<script>
import { errHandler } from '@/helpers'
import { mapGetters } from 'vuex'
import _debounce from 'lodash.debounce'
import DqPaginate from '@/components/Parts/DqPaginate'

export default {
  name: 'Location-Index',
  components: { DqPaginate },
  beforeMount () {
    this.$store.commit('loader/startIntLoading')
  },
  async mounted () {
    await this.$store.dispatch('location/resetFiltersCity')
    this.init(true)
    this.debouncedSearch = _debounce(async () => {
      await this.$store.dispatch('location/resetPageCity', { resetPage: true })
      this.dispatchList()
    }, 200)
  },
  data: () => {
    return {}
  },
  computed: {
    ...mapGetters('location', {
      locationList: 'locationList',
      lastPage: 'lastPageCity',
      total: 'totalCity',
      isFilterApplied: 'isFilterAppliedCity'
    }),
    search: {
      get () {
        return this.$store.getters['location/searchCity']
      },
      set (value) {
        this.$store.commit('location/setSearchCity', value)
      }
    },
    page: {
      get () {
        return this.$store.getters['location/currentPageCity']
      },
      set (value) {
        this.$store.commit('location/setPageCity', value)
      }
    }
  },
  methods: {
    async init (resetPage = false) {
      try {
        await this.$store.dispatch('location/resetPageCity', { resetPage })
        this.dispatchList()
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    async dispatchList () {
      try {
        await this.$store.dispatch('location/get')
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      } finally {
        this.$store.dispatch('loader/stopIntLoading')
      }
    }
  },
  watch: {
    search () {
      this.debouncedSearch()
    }
  },
  beforeDestroy () {
    this.$store.commit('location/clearItems')
  }
}
</script>
